/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */

function mapToParentSection(data) {

  return {

    ElectronicContactConsentAgreement: data.electronicConsentDocument === 'true' ? true : data.electronicConsentDocument === 'false' ? false : null,
    ElectronicContactEmail: data.electronicConsentDocument === 'true' ? data.emailAddress : '',

  };

}



function mapToQuestionnaire() {

  return [];

}



function mapToExpenses() {

  return [];

}



export default {

  mapToParentSection,

  mapToQuestionnaire,

  mapToExpenses,

};




// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepDeclarationDataMapper.js